<template>
  <div class="manage">
    <el-dialog
      :title="dialogForm.type === 'add' ? '新增配件入库' : '更新配件入库'"
      :visible.sync="dialogForm.isShow"
    >
      <el-form ref="form" label-width="100px" :model="dialogForm.formData" size="mini">
        <el-form-item label="配件名称" label-width="140px" style="width: 340px" prop="fitId">
          <el-select
            placeholder="请选择配件名称"
            v-model="dialogForm.formData.fitId"
            filterable
            remote
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="option in dialogForm.fitList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
              :disabled="option.disabled"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="入库日期" label-width="140px" style="width: 340px" prop="useTime">
          <el-date-picker v-model="dialogForm.formData.useTime" placeholder="请输入使用日期"/>
        </el-form-item>
        <el-form-item label="入库数量" label-width="140px" style="width: 340px" prop="count">
          <el-input-number
            placeholder="请输入使用数量"
            v-model.trim="dialogForm.formData.count"
          />
        </el-form-item>
        <el-form-item label="是否徐工" label-width="140px" style="width: 340px" prop="isThis">
          <el-radio-group v-model="dialogForm.formData.isThis">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" label-width="140px" style="width: 340px" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                    v-model.trim="dialogForm.formData.remark"
                    maxlength="100"
                    show-word-limit style="width:100%"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogForm.isShow = false">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>

    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="handleAdd" size="mini"
      >新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </div>

    <!---------------------------------- 搜索 ---------------------------------->
    <div class="manage-header">
      <el-form label-width="auto" :model="searchForm.formData"
               :inline="true" size="mini">
        <el-form-item label="配件名称" prop="fitId">
          <el-select
            placeholder="请选择配件名称"
            v-model="searchForm.formData.fitId"
            filterable
            remote
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="option in searchForm.fitList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
              :disabled="option.disabled"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否徐工" prop="isThis">
          <el-select
            placeholder="请选择是否徐工"
            v-model="searchForm.formData.isThis"
          >
            <el-option
              v-for="option in searchForm.formData.isThisList"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
        <el-date-picker
          v-model="searchForm.formData.dateRange"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00','00:00:00']">
        </el-date-picker>
        <el-form-item>
          <el-button type="primary" @click="search" size="mini">搜索 <i class="el-icon-search"/></el-button>
          <el-button type="danger" @click="reset" size="mini">重置 <i class="el-icon-refresh-left"/></el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-------------------------- 数据表格 ------------------>
    <div class="common-table">
      <el-table
        :data="table.tableData"
        height="85%"
        border
        stripe
        row-key="id"
        :header-cell-style="{background: '#eef1f6',color: '#606266',
        textAlign:'center',fontWeight:'bold',borderWidth:'3px'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center"/>
        <el-table-column prop="name" label="配件名称" min-width="80" align="center"/>
        <el-table-column prop="count" label="入库数量" min-width="200" align="center"/>
        <el-table-column prop="useTime" label="入库日期" min-width="200" align="center"/>
        <el-table-column prop="isThis" label="是否徐工" min-width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isThis === 0">否</span>
            <span v-else-if="scope.row.isThis === 1">是</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
            >编辑 <i class="el-icon-edit"></i
            ></el-button>
            <el-popconfirm
              style="margin-left:10px;margin-right:10px"
              confirm-button-text='确定'
              cancel-button-text='我再想想'
              icon="el-icon-info"
              icon-color="red"
              title="你确定删除吗？"
              @confirm="handleDelete(scope.row.id)"
            >
              <el-button size="mini" type="danger" slot="reference"
              >删除 <i class="el-icon-remove-outline"></i
              ></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
        :page-sizes="[5, 10, 15, 20]"
        :total="table.pageConfig.total"
        :current-page.sync="table.pageConfig.current"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {deleteOne, deleteBatch, add, edit, getList} from '@/api/fitCarTotal'
import {getAll} from '@/api/fitType'

export default {
  name: 'Role',
  data () {
    const now = new Date() // 获取当前日期时间
    function formatDateToYYYYMMDDHHMMSS (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    }
    return {
      dialogForm: {
        type: 'add', // add为新增，edit为编辑
        isShow: false,
        formData: {},
        fitList: [],
      },
      searchForm: {
        formData: {
          fitList: [],
          isThisList: [{
            value: 0,
            label: '否'
          }, {
            value: 1,
            label: '是'
          }],
          isThis: '',
          dateRange: [formatDateToYYYYMMDDHHMMSS(new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0)), formatDateToYYYYMMDDHHMMSS(new Date(now.setHours(23, 59, 59)))]
        },
      },
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      },
    }
  },
  computed: {
    ...mapState('token', ['token']),
    headers () {
      return { token: this.token }
    },
  },
  methods: {
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    // 点击新增按钮，弹出对话框
    handleAdd () {
      this.dialogForm.isShow = true
      this.dialogForm.type = 'add'
      this.dialogForm.formData = {}
    },
    handleDelete (id) {
      deleteOne(id).then(
        response => {
          if (response.code === 200) {
            this.$message.success('删除成功！')
            this.loading()
          } else {
            this.$message.error('删除失败！')
          }
        }
      )
    },
    handleDeleteBatch () {
      deleteBatch(this.ids).then(response => {
        if (response.code === 200) {
          this.$message.success('批量删除成功！')
          this.loading()
        } else {
          this.$message.error('批量删除失败！')
        }
      })
    },
    handleEdit (row) {
      this.dialogForm.isShow = true
      this.dialogForm.type = 'edit'
      this.dialogForm.formData = row
    },
    confirm () {
      // 通过type来判断是新增还是编辑
      if (this.dialogForm.type === 'add') {
        this.dialogForm.formData.deptId = this.$store.state.staff.staff.deptId
        add(this.dialogForm.formData).then((response) => {
          if (response.code === 200) {
            this.$message.success('添加成功！')
            this.dialogForm.isShow = false
            this.loading()
          } else {
            this.$message.error('添加失败！')
          }
        })
      } else {
        edit(this.dialogForm.formData).then((response) => {
          if (response.code === 200) {
            this.$message.success('修改成功！')
            this.dialogForm.isShow = false
            this.loading()
          } else {
            this.$message.error('修改失败！')
          }
        })
      }
    },
    search () {
      this.loading()
    },
    // 重置搜索表单
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    handleSelectionChange (list) {
      this.ids = list.map(item => item.id)
    },
    remoteMethod(e) {
      getAll({name: e, myDeptId: this.$store.state.staff.staff.deptId}).then(response => {
        if (response.code === 200) {
          this.dialogForm.fitList = response.data
          this.searchForm.fitList = response.data
        } else {
          this.$message.error(response.message)
        }
      })
    },
    // 将数据渲染到模板
    loading () {
      getAll({name: '', myDeptId: this.$store.state.staff.staff.deptId}).then(response => {
        if (response.code === 200) {
          this.dialogForm.fitList = response.data
          this.searchForm.fitList = response.data
        } else {
          this.$message.error(response.message)
        }
      })

      const a = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0])
      const b = this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1])
      this.searchForm.formData.dateRange = [a, b]
      getList({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        startTime: this.searchForm.formData.dateRange[0],
        endTime: this.searchForm.formData.dateRange[1],
        myDeptId: this.$store.state.staff.staff.deptId,
        fitId: this.searchForm.formData.fitId,
        isThis: this.searchForm.formData.isThis
      }).then(response => {
        if (response.code === 200) {
          this.table.tableData = response.data.list
          this.table.pageConfig.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      })
    },
  },
  created () {
    this.loading()
  }
}
</script>
